import axios from 'axios';
import { API_BASE_URL } from '../config/config';
import { handleSessionExpired } from '../utils/sessionExpiredHandler';

interface StatusTrackingStep {
  toStatus: string;
  levelNumber: number;
}

interface StatusTrackingResponse {
  success: boolean;
  formName: string;
  statusTracking: StatusTrackingStep[];
  message?: string;
}

class StatusTrackingService {
  private apiUrl = API_BASE_URL;

  async getStatusTracking(formName: string): Promise<StatusTrackingResponse> {
    try {
      const token = localStorage.getItem('authToken');

      if (!token) {
        throw new Error('No authentication token found');
      }

      console.log('Fetching status tracking for form:', formName);

      const response = await axios.post(
        `${this.apiUrl}/CustomerPortal/ticket-status-tracking`,
        {
          formName: formName
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Status tracking response:', response.data);

      // Transform the response to match expected format
      // API returns: ToStatus, LevelNumber
      // Code expects: toStatus, levelNumber
      if (response.data && response.data.statusTracking) {
        const transformedTracking = response.data.statusTracking.map((step: any) => ({
          toStatus: step.ToStatus || step.toStatus || '',
          levelNumber: step.LevelNumber || step.levelNumber || 0
        }));

        return {
          success: response.data.success,
          formName: response.data.formName,
          statusTracking: transformedTracking,
          message: response.data.message
        };
      }

      return response.data;
    } catch (error: any) {
      console.error('Failed to fetch status tracking:', error);

      if (error.response?.status === 401) {
        handleSessionExpired();
        return { success: false, formName: '', statusTracking: [], message: 'Session expired' };
      }

      throw new Error(error.response?.data?.message || 'Failed to fetch status tracking');
    }
  }
}

export default new StatusTrackingService();